import { Box, Link } from '@mui/material';

function ShareButtons({ title, url }) {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
      }}
    >
      <Box
        component="span"
        sx={{
          fontSize: '0.9rem',
          color: 'text.secondary',
        }}
      >
        Share:
      </Box>
      <Link
        href={shareLinks.twitter}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontSize: '0.9rem',
          color: 'text.primary',
          textDecoration: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            borderColor: 'text.primary',
            opacity: 0.7,
          },
        }}
      >
        Twitter
      </Link>
      <Link
        href={shareLinks.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontSize: '0.9rem',
          color: 'text.primary',
          textDecoration: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            borderColor: 'text.primary',
            opacity: 0.7,
          },
        }}
      >
        LinkedIn
      </Link>
    </Box>
  );
}

export default ShareButtons;
